import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=57590911&scoped=true&"
import script from "./basic.vue?vue&type=script&lang=js&"
export * from "./basic.vue?vue&type=script&lang=js&"
import style0 from "./basic.vue?vue&type=style&index=0&id=57590911&prod&lang=scss&scoped=true&"
import style1 from "./basic.vue?vue&type=style&index=1&id=57590911&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57590911",
  null
  
)

export default component.exports